import { render, staticRenderFns } from "./Albums.vue?vue&type=template&id=e4dcb912&"
import script from "./Albums.vue?vue&type=script&lang=js&"
export * from "./Albums.vue?vue&type=script&lang=js&"
import style0 from "./Albums.vue?vue&type=style&index=0&id=e4dcb912&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports